<template>
    <div class="tableCell verticalAlignTop lightGrey">
        Wird zur Zeit nicht unterstützt!
    </div>
</template>
<script>
	export default {
		name: 'profileUnsupportedEditor',
		props: {
            item: Object,
            question: Object
        },
        data: function() {
        	return {
        	}
        },
        created: function() {
        },
        methods: {
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileUnsupportedEditor.vue?7d94d4a9